import { render } from "./ManageOrderPersonModal.vue?vue&type=template&id=0b9b9ac0&scoped=true"
import script from "./ManageOrderPersonModal.vue?vue&type=script&lang=js"
export * from "./ManageOrderPersonModal.vue?vue&type=script&lang=js"

import "./ManageOrderPersonModal.vue?vue&type=style&index=0&id=0b9b9ac0&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b9b9ac0"]])

export default __exports__